module.exports = __webpack_public_path__ + "static/media/16.04f1f620.jpg";